(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["home-app-usage"] && !Shopify.designMode) return;
  try {
    (function () {
  var SELECTORS = {
    stage: '[data-app-usage-stage]',
    title: '[data-app-usage-title]',
    phone: '[data-app-usage-phone]',
    copy: '[data-app-usage-copy]'
  };

  /* Design values at the 1920 base; everything scales with the viewport. */
  var PHONE_START_SCALE = 600 / 432;
  var PHONE_START_TOP_DELTA = 356; /* state 1 top (470) minus final top (114) */
  var PHONE_FINAL_SHIFT = 298;

  function vwPx(designPx) {
    return designPx * Math.min(1, window.innerWidth / 1920);
  }

  /* Block scripts run in bundle order, not document order, so this trigger is
     created before the pinned sections above it. GSAP only adds preceding pin
     distances to triggers processed later in its internal array, so sort by
     document position before refreshing or the pin here fires early by the
     sum of the preceding pin distances. */
  function refreshTriggers() {
    if (!window.ScrollTrigger) return;
    if (ScrollTrigger.sort) ScrollTrigger.sort();
    ScrollTrigger.refresh();
  }

  /* Lazy media above this section can also grow the page after init, which
     leaves ScrollTrigger start positions stale and makes the pin fire early.
     Watch the body height and re-measure every trigger when it changes. */
  var layoutWatcher = null;
  var layoutWatcherUsers = 0;
  var lastBodyHeight = 0;
  var refreshTimer = null;

  function watchLayout() {
    layoutWatcherUsers += 1;
    if (layoutWatcher || !('ResizeObserver' in window)) return;
    lastBodyHeight = document.body.scrollHeight;
    layoutWatcher = new ResizeObserver(function () {
      var height = document.body.scrollHeight;
      if (Math.abs(height - lastBodyHeight) < 2) return;
      lastBodyHeight = height;
      if (refreshTimer) clearTimeout(refreshTimer);
      refreshTimer = setTimeout(function () {
        refreshTimer = null;
        refreshTriggers();
        lastBodyHeight = document.body.scrollHeight;
      }, 250);
    });
    layoutWatcher.observe(document.body);
  }

  function unwatchLayout() {
    layoutWatcherUsers = Math.max(0, layoutWatcherUsers - 1);
    if (layoutWatcherUsers === 0 && layoutWatcher) {
      layoutWatcher.disconnect();
      layoutWatcher = null;
      if (refreshTimer) {
        clearTimeout(refreshTimer);
        refreshTimer = null;
      }
    }
  }

  function getParts(root) {
    return {
      stage: root.querySelector(SELECTORS.stage),
      title: root.querySelector(SELECTORS.title),
      phone: root.querySelector(SELECTORS.phone),
      copy: root.querySelector(SELECTORS.copy)
    };
  }

  function clearStyles(root) {
    var parts = getParts(root);
    Object.keys(parts).forEach(function (key) {
      if (parts[key]) parts[key].style.cssText = '';
    });
  }

  function teardown(root) {
    if (root._appUsageTimeline) {
      if (root._appUsageTimeline.scrollTrigger) {
        root._appUsageTimeline.scrollTrigger.kill(true);
      }
      root._appUsageTimeline.kill();
      root._appUsageTimeline = null;
    }
    clearStyles(root);
  }

  function setupDesktop(root) {
    var parts = getParts(root);
    if (!parts.stage || !parts.phone || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    teardown(root);
    parts = getParts(root);

    var timeline = gsap.timeline({
      scrollTrigger: {
        trigger: parts.stage,
        start: 'bottom bottom',
        end: '+=1600',
        pin: true,
        scrub: 0.6,
        anticipatePin: 1,
        invalidateOnRefresh: true
      }
    });

    /* Phase 1 (0 - 0.45): title slides up while fading out, phone shrinks and
       rises to center. */
    if (parts.title) {
      timeline.fromTo(
        parts.title,
        { autoAlpha: 1, xPercent: -50, x: 0, y: 0 },
        { autoAlpha: 0, y: function () { return -vwPx(320); }, duration: 0.5, ease: 'none' },
        0
      );
    }
    timeline.fromTo(
      parts.phone,
      {
        xPercent: -50,
        x: 0,
        y: function () { return vwPx(PHONE_START_TOP_DELTA); },
        scale: PHONE_START_SCALE,
        transformOrigin: '50% 0%'
      },
      { y: 0, scale: 1, duration: 0.45, ease: 'none' },
      0
    );

    /* Hold (0.45 - 0.55), then phase 2 (0.55 - 0.9): phone slides left while the
       copy fades in with the same start and duration, finishing together. */
    timeline.to(parts.phone, {
      x: function () { return -vwPx(PHONE_FINAL_SHIFT); },
      duration: 0.35,
      ease: 'none'
    }, 0.55);
    if (parts.copy) {
      timeline.fromTo(parts.copy, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.35, ease: 'none' }, 0.55);
    }

    /* Hold the final state (0.9 - 1) before releasing the pin. */
    timeline.to({}, { duration: 0.1 }, 0.9);

    root._appUsageTimeline = timeline;
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    var desktop = window.matchMedia('(min-width: 769px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function apply() {
      if (desktop.matches && !reduce.matches) {
        setupDesktop(root);
      }       else {
        /* Mobile and reduced motion keep the static final layout from CSS. */
        teardown(root);
      }
      refreshTriggers();
    }

    apply();
    watchLayout();
    var onChange = apply;
    if (desktop.addEventListener) {
      desktop.addEventListener('change', onChange);
      reduce.addEventListener('change', onChange);
    } else {
      desktop.addListener(onChange);
      reduce.addListener(onChange);
    }

    root._homeAppUsageCleanup = function () {
      if (desktop.removeEventListener) {
        desktop.removeEventListener('change', onChange);
        reduce.removeEventListener('change', onChange);
      } else {
        desktop.removeListener(onChange);
        reduce.removeListener(onChange);
      }
      unwatchLayout();
      teardown(root);
      root.dataset.initialized = 'false';
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-home-app-usage]').forEach(init);
    /* Runs after every other block's init in the same event tick, so all
       triggers exist before the sorted refresh. */
    window.setTimeout(refreshTriggers, 0);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-home-app-usage]').forEach(function (root) {
      if (root._homeAppUsageCleanup) root._homeAppUsageCleanup();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-app-video"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var stage = root.querySelector('[data-app-video-stage]');
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-atmosphere-video]'));
    if (!videos.length) return;

    function activeVideo() {
      return videos.filter(function (video) {
        return getComputedStyle(video).display !== 'none';
      })[0] || videos[0];
    }

    function play() {
      var video = activeVideo();
      if (!video) return;
      video.play().catch(function () {});
    }

    function pause() {
      videos.forEach(function (video) {
        video.pause();
      });
    }

    var stopVideo;
    if (window.xleanHomeVideo && stage) {
      stopVideo = window.xleanHomeVideo.bind(stage, videos, play, pause);
    } else {
      play();
    }

    root._homeAppVideoCleanup = function () {
      pause();
      if (stopVideo) stopVideo();
      root.dataset.initialized = 'false';
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-home-app-video]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-home-app-video]').forEach(function (root) {
      if (root._homeAppVideoCleanup) root._homeAppVideoCleanup();
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-cleaning-efficiency-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
  const mq = window.matchMedia('(min-width: 769px)');

  function markSlides(swiperEl) {
    swiperEl.querySelectorAll('.swiper-wrapper > .shopify-block').forEach(function (slide) {
      slide.classList.add('swiper-slide');
    });
  }

  function unmarkSlides(root) {
    const swiperEl = root.querySelector('[data-carousel-swiper]');
    if (!swiperEl) return;
    swiperEl.querySelectorAll('.swiper-wrapper > .shopify-block').forEach(function (slide) {
      slide.classList.remove('swiper-slide');
    });
  }

  function destroySwiper(root) {
    if (root._efficiencySwiper) {
      root._efficiencySwiper.destroy(true, true);
      root._efficiencySwiper = null;
    }
    unmarkSlides(root);
  }

  function initSwiper(root) {
    const swiperEl = root.querySelector('[data-carousel-swiper]');
    const prev = root.querySelector('.home-cleaning-efficiency-carousel__arrow--prev');
    const next = root.querySelector('.home-cleaning-efficiency-carousel__arrow--next');
    if (!swiperEl || typeof Swiper === 'undefined') return;
    destroySwiper(root);
    markSlides(swiperEl);
    root._efficiencySwiper = new Swiper(swiperEl, {
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 36,
      speed: 700,
      grabCursor: true,
      watchOverflow: true,
      mousewheel: { forceToAxis: true, sensitivity: 1, releaseOnEdges: true },
      navigation: {
        prevEl: prev,
        nextEl: next
      }
    });
  }

  function sync(root) {
    if (mq.matches) initSwiper(root);
    else destroySwiper(root);
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    const swiperEl = root.querySelector('[data-carousel-swiper]');
    if (!swiperEl) return;
    if (typeof Swiper === 'undefined') {
      setTimeout(function () {
        init(root);
      }, 200);
      return;
    }
    root.dataset.initialized = 'true';
    if (mq.matches) markSlides(swiperEl);

    function onChange() {
      sync(root);
    }

    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);

    function onBlockSelect(event) {
      const slide = event.target.closest('.swiper-slide');
      if (!slide || !swiperEl.contains(slide)) return;
      if (root._efficiencySwiper) {
        const index = Array.prototype.indexOf.call(root._efficiencySwiper.slides, slide);
        if (index >= 0) root._efficiencySwiper.slideTo(index);
      }
    }

    root.addEventListener('shopify:block:select', onBlockSelect);
    sync(root);

    root._homeCleaningEfficiencyCarouselCleanup = function () {
      destroySwiper(root);
      root.removeEventListener('shopify:block:select', onBlockSelect);
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else mq.removeListener(onChange);
      root.dataset.initialized = 'false';
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-home-cleaning-efficiency-carousel]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-home-cleaning-efficiency-carousel]').forEach(function (root) {
      if (root._homeCleaningEfficiencyCarouselCleanup) root._homeCleaningEfficiencyCarouselCleanup();
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-cleaning-efficiency-video"] && !Shopify.designMode) return;
  try {
    (function () {
  function visibleVideo(root) {
    const videos = root.querySelectorAll('[data-efficiency-video]');
    for (let i = 0; i < videos.length; i++) {
      if (window.getComputedStyle(videos[i]).display !== 'none') return videos[i];
    }
    return videos[0] || null;
  }

  function pauseAll(root) {
    root.querySelectorAll('[data-efficiency-video]').forEach(function (video) {
      video.pause();
    });
  }

  function syncToggle(root, playing) {
    const toggle = root.querySelector('[data-video-toggle]');
    const icon = root.querySelector('[data-video-icon]');
    if (toggle) toggle.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    if (icon) icon.src = playing ? icon.dataset.pauseSrc : icon.dataset.playSrc;
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    const videos = root.querySelectorAll('[data-efficiency-video]');
    if (!videos.length) return;
    root.dataset.initialized = 'true';

    const frame = root.querySelector('.home-cleaning-efficiency-video__frame');
    const toggle = root.querySelector('[data-video-toggle]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let userPaused = reduceMotion;
    let stopVideo;

    function playCurrent() {
      const video = visibleVideo(root);
      if (!video || userPaused) return;
      videos.forEach(function (item) {
        if (item !== video) item.pause();
      });
      video.play().catch(function () {});
      syncToggle(root, true);
    }

    function pauseCurrent() {
      pauseAll(root);
      syncToggle(root, false);
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        const video = visibleVideo(root);
        if (!video) return;
        if (video.paused) {
          userPaused = false;
          playCurrent();
        } else {
          userPaused = true;
          pauseCurrent();
        }
      });
    }

    if (window.xleanHomeVideo && frame) {
      stopVideo = window.xleanHomeVideo.bind(frame, videos, playCurrent, pauseCurrent);
    }

    if (reduceMotion) syncToggle(root, false);

    root._homeCleaningEfficiencyVideoCleanup = function () {
      pauseCurrent();
      if (stopVideo) stopVideo();
      root.dataset.initialized = 'false';
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-home-cleaning-efficiency-video]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-home-cleaning-efficiency-video]').forEach(function (root) {
      if (root._homeCleaningEfficiencyVideoCleanup) root._homeCleaningEfficiencyVideoCleanup();
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-cleaning-power-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
  function playActive(root, swiper) {
    const slides = Array.prototype.slice.call(root.querySelectorAll('.swiper-slide'));
    const activeIndex = swiper ? swiper.activeIndex : 0;
    slides.forEach(function (slide, index) {
      const video = slide.querySelector('.home-cleaning-power-slide__media video');
      if (!video) return;
      if (index === activeIndex) {
        if (window.xleanHomeVideo) window.xleanHomeVideo.warm(video);
        video.play().catch(function () {});
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  function pauseAll(root) {
    root.querySelectorAll('.home-cleaning-power-slide__media video').forEach(function (video) {
      video.pause();
    });
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    const swiperEl = root.querySelector('[data-carousel-swiper]');
    const prev = root.querySelector('.home-cleaning-power-carousel__arrow--prev');
    const next = root.querySelector('.home-cleaning-power-carousel__arrow--next');
    if (!swiperEl) return;
    if (typeof Swiper === 'undefined') {
      setTimeout(function () {
        init(root);
      }, 200);
      return;
    }
    root.dataset.initialized = 'true';

    swiperEl.querySelectorAll('.swiper-wrapper > .shopify-block').forEach(function (slide) {
      slide.classList.add('swiper-slide');
    });

    const swiper = new Swiper(swiperEl, {
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 16,
      speed: 700,
      grabCursor: true,
      watchOverflow: true,
      mousewheel: { forceToAxis: true, sensitivity: 1, releaseOnEdges: true },
      navigation: {
        prevEl: prev,
        nextEl: next
      },
      breakpoints: {
        769: {
          spaceBetween: 36
        }
      }
    });

    function onSlideChange() {
      playActive(root, swiper);
    }

    swiper.on('slideChange', onSlideChange);
    swiper.on('reachEnd', onSlideChange);

    let observer;
    if (window.xleanHomeVideo) {
      observer = {
        disconnect: window.xleanHomeVideo.bind(root, root.querySelectorAll('.home-cleaning-power-slide__media video'), function () {
          playActive(root, swiper);
        }, function () {
          pauseAll(root);
        })
      };
    } else if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        const entry = entries[0];
        if (entry.isIntersecting) playActive(root, swiper);
        else pauseAll(root);
      }, { threshold: 0.2 });
      observer.observe(root);
    }

    function onBlockSelect(event) {
      const slide = event.target.closest('.swiper-slide');
      if (!slide || !swiperEl.contains(slide)) return;
      const index = Array.prototype.indexOf.call(swiper.slides, slide);
      if (index >= 0) swiper.slideTo(index);
    }

    root.addEventListener('shopify:block:select', onBlockSelect);

    root._homeCleaningPowerCarouselCleanup = function () {
      pauseAll(root);
      if (observer) observer.disconnect();
      root.removeEventListener('shopify:block:select', onBlockSelect);
      swiper.destroy(true, true);
      root.dataset.initialized = 'false';
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-home-cleaning-power-carousel]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-home-cleaning-power-carousel]').forEach(function (root) {
      if (root._homeCleaningPowerCarouselCleanup) root._homeCleaningPowerCarouselCleanup();
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-cleaning-power-compare"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const clips = Array.prototype.slice.call(root.querySelectorAll('[data-compare-clip]'));
    const metrics = root.querySelector('[data-compare-metrics]');
    const fills = Array.prototype.slice.call(root.querySelectorAll('[data-bar-fill]'));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const clipObservers = [];
    let metricsObserver;
    let barTimeline;

    function clipVideos(clip) {
      return Array.prototype.slice.call(clip.querySelectorAll('[data-compare-video]'));
    }

    function activeClipVideo(clip) {
      const videos = clipVideos(clip);
      return videos.filter(function (video) {
        return getComputedStyle(video).display !== 'none';
      })[0] || videos[0];
    }

    function playClip(clip) {
      const video = activeClipVideo(clip);
      if (video) video.play().catch(function () {});
    }

    function pauseClip(clip) {
      clipVideos(clip).forEach(function (video) {
        video.pause();
      });
    }

    function pauseAllClips() {
      clips.forEach(pauseClip);
    }

    if (window.xleanHomeVideo) {
      clips.forEach(function (clip) {
        clipObservers.push(window.xleanHomeVideo.bind(clip, clipVideos(clip), function () {
          playClip(clip);
        }, function () {
          pauseClip(clip);
        }));
      });
    } else if ('IntersectionObserver' in window) {
      clips.forEach(function (clip) {
        const observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) playClip(clip);
            else pauseClip(clip);
          });
        }, { threshold: 0.2 });
        observer.observe(clip);
        clipObservers.push(function () {
          observer.disconnect();
        });
      });
    } else {
      clips.forEach(playClip);
    }

    function setFinalBars() {
      fills.forEach(function (el) {
        el.style.width = (el.getAttribute('data-width') || '0') + '%';
      });
    }

    function animateBars() {
      if (!fills.length) return;
      if (typeof gsap === 'undefined') {
        setFinalBars();
        return;
      }
      fills.forEach(function (el) {
        gsap.set(el, { width: '0%' });
      });
      barTimeline = gsap.timeline();
      fills.forEach(function (el, index) {
        barTimeline.to(el, {
          width: (el.getAttribute('data-width') || '0') + '%',
          duration: 1
        }, index === 0 ? 0 : '<+=30%');
      });
    }

    if (metrics && fills.length) {
      if ('IntersectionObserver' in window && !reduceMotion) {
        metricsObserver = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          animateBars();
          metricsObserver.disconnect();
          metricsObserver = null;
        }, { threshold: 0.2 });
        metricsObserver.observe(metrics);
      } else {
        setFinalBars();
      }
    }

    root._homeCleaningPowerCompareCleanup = function () {
      pauseAllClips();
      clipObservers.forEach(function (observer) {
        if (typeof observer === 'function') observer();
        else observer.disconnect();
      });
      if (metricsObserver) metricsObserver.disconnect();
      if (barTimeline) {
        barTimeline.kill();
        barTimeline = null;
      }
      root.dataset.initialized = 'false';
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-home-cleaning-power-compare]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-home-cleaning-power-compare]').forEach(function (root) {
      if (root._homeCleaningPowerCompareCleanup) root._homeCleaningPowerCompareCleanup();
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-cleaning-power-video"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const stage = root.querySelector('[data-video-stage]');
    const scroll = root.querySelector('[data-video-scroll]');
    const videos = Array.prototype.slice.call(root.querySelectorAll('[data-atmosphere-video]'));
    const toggle = root.querySelector('[data-video-toggle]');
    const icon = root.querySelector('[data-video-icon]');
    const intro = root.querySelector('[data-video-intro]');
    const overlay = root.querySelector('.home-cleaning-power-video__overlay');
    let userPaused = false;
    let frameRequest;
    let videoObserver;

    function activeVideo() {
      return videos.filter(function (video) {
        return getComputedStyle(video).display !== 'none';
      })[0] || videos[0];
    }

    function play() {
      const video = activeVideo();
      if (!video || userPaused) return;
      videos.forEach(function (item) {
        if (item !== video) item.pause();
      });
      video.play().catch(function () {});
      if (toggle) {
        toggle.classList.add('is-playing');
        toggle.setAttribute('aria-label', 'Pause video');
      }
      if (icon) icon.src = icon.dataset.pauseSrc;
    }

    function pause() {
      videos.forEach(function (video) {
        video.pause();
      });
      if (toggle) {
        toggle.classList.remove('is-playing');
        toggle.setAttribute('aria-label', 'Play video');
      }
      if (icon) icon.src = icon.dataset.playSrc;
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        const video = activeVideo();
        if (!video) return;
        if (video.paused) {
          userPaused = false;
          play();
        } else {
          userPaused = true;
          pause();
        }
      });
    }

    function updateIntro() {
      if (!intro || !overlay || !scroll || !stage) return;
      const rect = scroll.getBoundingClientRect();
      const viewportH = window.innerHeight;
      const stageH = stage.offsetHeight;
      const distance = Math.max(scroll.offsetHeight - stageH, 1);
      const progress = Math.max(0, Math.min(1, -rect.top / distance));
      const offset = -Math.min(viewportH * 0.72, 581) * progress;
      intro.style.transform = 'translateY(' + offset + 'px)';
      intro.style.opacity = String(1 - progress);
      overlay.style.opacity = String(1 - progress);
      overlay.style.pointerEvents = progress >= 1 ? 'none' : 'auto';
    }

    function onScroll() {
      if (frameRequest) return;
      frameRequest = window.requestAnimationFrame(function () {
        frameRequest = null;
        updateIntro();
      });
    }

    if (stage && 'IntersectionObserver' in window) {
      videoObserver = new IntersectionObserver(function (entries) {
        if (!entries[0]) return;
        if (entries[0].intersectionRatio >= 0.3) {
          if (window.xleanHomeVideo) window.xleanHomeVideo.warm(activeVideo());
          play();
        } else {
          pause();
        }
      }, { threshold: [0, 0.3] });
      videoObserver.observe(stage);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateIntro();

    root._homeCleaningPowerVideoCleanup = function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (frameRequest) window.cancelAnimationFrame(frameRequest);
      if (videoObserver) videoObserver.disconnect();
      pause();
      if (intro) {
        intro.style.transform = '';
        intro.style.opacity = '';
      }
      if (overlay) {
        overlay.style.opacity = '';
        overlay.style.pointerEvents = '';
      }
      root.dataset.initialized = 'false';
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-home-cleaning-power-video]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-home-cleaning-power-video]').forEach(function (root) {
      if (root._homeCleaningPowerVideoCleanup) root._homeCleaningPowerVideoCleanup();
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-closing-in-the-box"] && !Shopify.designMode) return;
  try {
    (function () {
  var ATTR = 'data-xh-tabs-bound';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function getRoots(scope) {
    var root = scope || document;
    if (root.nodeType === 1 && root.getAttribute && root.getAttribute('data-xh-tabs') !== null) {
      return [root];
    }
    return toArray(root.querySelectorAll('[data-xh-tabs]'));
  }

  function getTabs(root) {
    return toArray(root.querySelectorAll('[data-xh-tab]'));
  }

  function getPanels(root) {
    return toArray(root.querySelectorAll('[data-xh-tabpanel]'));
  }

  function activate(root, nextIndex, moveFocus) {
    var tabs = getTabs(root);
    var panels = getPanels(root);
    if (!tabs.length) return;

    var index = nextIndex;
    if (index < 0) index = tabs.length - 1;
    if (index >= tabs.length) index = 0;

    tabs.forEach(function (tab, i) {
      var selected = i === index;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.setAttribute('tabindex', selected ? '0' : '-1');
      if (selected && moveFocus && typeof tab.focus === 'function') {
        tab.focus();
      }
    });

    panels.forEach(function (panel, i) {
      if (i === index) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', 'hidden');
      }
    });
  }

  function selectedIndex(tabs) {
    var i;
    for (i = 0; i < tabs.length; i += 1) {
      if (tabs[i].getAttribute('aria-selected') === 'true') return i;
    }
    return 0;
  }

  function onKeydown(event) {
    var tab = event.currentTarget;
    var root = tab.closest('[data-xh-tabs]');
    if (!root) return;

    var tabs = getTabs(root);
    var index = selectedIndex(tabs);
    var next = index;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      next = index + 1;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      next = index - 1;
    } else if (event.key === 'Home') {
      next = 0;
    } else if (event.key === 'End') {
      next = tabs.length - 1;
    } else if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      activate(root, index, false);
      return;
    } else {
      return;
    }

    event.preventDefault();
    activate(root, next, true);
  }

  function onClick(event) {
    var tab = event.currentTarget;
    var root = tab.closest('[data-xh-tabs]');
    if (!root) return;
    var tabs = getTabs(root);
    activate(root, tabs.indexOf(tab), false);
  }

  function bind(root) {
    if (!root || root.getAttribute(ATTR) === 'true') return;
    var tabs = getTabs(root);
    if (tabs.length < 1) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', onClick);
      tab.addEventListener('keydown', onKeydown);
    });

    root.setAttribute(ATTR, 'true');
    activate(root, selectedIndex(tabs), false);
  }

  function unbind(root) {
    if (!root || root.getAttribute(ATTR) !== 'true') return;
    getTabs(root).forEach(function (tab) {
      tab.removeEventListener('click', onClick);
      tab.removeEventListener('keydown', onKeydown);
    });
    root.removeAttribute(ATTR);
  }

  function initAll(scope) {
    getRoots(scope).forEach(bind);
  }

  function destroyAll(scope) {
    getRoots(scope).forEach(unbind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-dual-form-handheld"] && !Shopify.designMode) return;
  try {
    (function () {
  function playActive(root, swiper) {
    const slides = Array.prototype.slice.call(root.querySelectorAll('.swiper-slide'));
    const activeIndex = swiper ? swiper.activeIndex : 0;
    slides.forEach(function (slide, index) {
      const video = slide.querySelector('.home-dual-form-handheld__media video');
      if (!video) return;
      if (index === activeIndex) {
        if (window.xleanHomeVideo) window.xleanHomeVideo.warm(video);
        video.play().catch(function () {});
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  function pauseAll(root) {
    root.querySelectorAll('.home-dual-form-handheld__media video').forEach(function (video) {
      video.pause();
    });
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    const swiperEl = root.querySelector('[data-handheld-swiper]');
    const prev = root.querySelector('.home-dual-form-handheld__arrow--prev');
    const next = root.querySelector('.home-dual-form-handheld__arrow--next');
    if (!swiperEl) return;
    if (typeof Swiper === 'undefined') {
      setTimeout(function () {
        init(root);
      }, 200);
      return;
    }
    root.dataset.initialized = 'true';

    swiperEl.querySelectorAll('.swiper-wrapper > .shopify-block').forEach(function (slide) {
      slide.classList.add('swiper-slide');
    });

    const swiper = new Swiper(swiperEl, {
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 15,
      speed: 700,
      grabCursor: true,
      watchOverflow: true,
      mousewheel: { forceToAxis: true, sensitivity: 1, releaseOnEdges: true },
      navigation: {
        prevEl: prev,
        nextEl: next
      },
      breakpoints: {
        769: {
          spaceBetween: 30
        }
      }
    });

    function onSlideChange() {
      playActive(root, swiper);
    }

    swiper.on('slideChange', onSlideChange);
    swiper.on('reachEnd', onSlideChange);

    let observer;
    if (window.xleanHomeVideo) {
      observer = {
        disconnect: window.xleanHomeVideo.bind(root, root.querySelectorAll('.home-dual-form-handheld__media video'), function () {
          playActive(root, swiper);
        }, function () {
          pauseAll(root);
        })
      };
    } else if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        const entry = entries[0];
        if (entry.isIntersecting) playActive(root, swiper);
        else pauseAll(root);
      }, { threshold: 0.2 });
      observer.observe(root);
    }

    function onBlockSelect(event) {
      const slide = event.target.closest('.swiper-slide');
      if (!slide || !swiperEl.contains(slide)) return;
      const index = Array.prototype.indexOf.call(swiper.slides, slide);
      if (index >= 0) swiper.slideTo(index);
    }

    root.addEventListener('shopify:block:select', onBlockSelect);

    root._homeDualFormHandheldCleanup = function () {
      pauseAll(root);
      if (observer) observer.disconnect();
      root.removeEventListener('shopify:block:select', onBlockSelect);
      swiper.destroy(true, true);
      root.dataset.initialized = 'false';
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-home-dual-form-handheld]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-home-dual-form-handheld]').forEach(function (root) {
      if (root._homeDualFormHandheldCleanup) root._homeDualFormHandheldCleanup();
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-dual-form-video"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const stage = root.querySelector('[data-video-stage]');
    const scroll = root.querySelector('[data-video-scroll]');
    const videos = Array.prototype.slice.call(root.querySelectorAll('[data-atmosphere-video]'));
    const toggle = root.querySelector('[data-video-toggle]');
    const icon = root.querySelector('[data-video-icon]');
    const intro = root.querySelector('[data-video-intro]');
    const overlay = root.querySelector('.home-dual-form-video__overlay');
    let userPaused = false;
    let frameRequest;
    let videoObserver;

    function activeVideo() {
      return videos.filter(function (video) {
        return getComputedStyle(video).display !== 'none';
      })[0] || videos[0];
    }

    function play() {
      const video = activeVideo();
      if (!video || userPaused) return;
      videos.forEach(function (item) {
        if (item !== video) item.pause();
      });
      video.play().catch(function () {});
      if (toggle) {
        toggle.classList.add('is-playing');
        toggle.setAttribute('aria-label', 'Pause video');
      }
      if (icon) icon.src = icon.dataset.pauseSrc;
    }

    function pause() {
      videos.forEach(function (video) {
        video.pause();
      });
      if (toggle) {
        toggle.classList.remove('is-playing');
        toggle.setAttribute('aria-label', 'Play video');
      }
      if (icon) icon.src = icon.dataset.playSrc;
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        const video = activeVideo();
        if (!video) return;
        if (video.paused) {
          userPaused = false;
          play();
        } else {
          userPaused = true;
          pause();
        }
      });
    }

    function updateIntro() {
      if (!intro || !overlay || !scroll || !stage) return;
      const rect = scroll.getBoundingClientRect();
      const viewportH = window.innerHeight;
      const stageH = stage.offsetHeight;
      const distance = Math.max(scroll.offsetHeight - stageH, 1);
      const progress = Math.max(0, Math.min(1, -rect.top / distance));
      const offset = -Math.min(viewportH * 0.72, 581) * progress;
      intro.style.transform = 'translateY(' + offset + 'px)';
      intro.style.opacity = String(1 - progress);
      overlay.style.opacity = String(1 - progress);
      overlay.style.pointerEvents = progress >= 1 ? 'none' : 'auto';
    }

    function onScroll() {
      if (frameRequest) return;
      frameRequest = window.requestAnimationFrame(function () {
        frameRequest = null;
        updateIntro();
      });
    }

    if (stage && 'IntersectionObserver' in window) {
      videoObserver = new IntersectionObserver(function (entries) {
        if (!entries[0]) return;
        if (entries[0].intersectionRatio >= 0.3) {
          if (window.xleanHomeVideo) window.xleanHomeVideo.warm(activeVideo());
          play();
        } else {
          pause();
        }
      }, { threshold: [0, 0.3] });
      videoObserver.observe(stage);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateIntro();

    root._homeDualFormVideoCleanup = function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (frameRequest) window.cancelAnimationFrame(frameRequest);
      if (videoObserver) videoObserver.disconnect();
      pause();
      if (intro) {
        intro.style.transform = '';
        intro.style.opacity = '';
      }
      if (overlay) {
        overlay.style.opacity = '';
        overlay.style.pointerEvents = '';
      }
      root.dataset.initialized = 'false';
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-home-dual-form-video]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-home-dual-form-video]').forEach(function (root) {
      if (root._homeDualFormVideoCleanup) root._homeDualFormVideoCleanup();
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-ease-activity"] && !Shopify.designMode) return;
  try {
    (function () {
  function media() {
    return {
      desktop: window.matchMedia('(min-width: 769px)'),
      reduce: window.matchMedia('(prefers-reduced-motion: reduce)')
    };
  }

  function clear(root) {
    var cards = root.querySelectorAll('[data-activity-card]');
    var headings = root.querySelectorAll('[data-activity-heading]');
    for (var i = 0; i < cards.length; i++) cards[i].style.cssText = '';
    for (var j = 0; j < headings.length; j++) headings[j].style.cssText = '';
  }

  function kill(root) {
    var tweens = root._easeActivityTweens || [];
    for (var i = 0; i < tweens.length; i++) {
      // Dispose the trigger as well as the tween so section re-initialisation
      // cannot stack multiple scroll listeners and accelerate the transition.
      if (tweens[i].scrollTrigger) tweens[i].scrollTrigger.kill(true);
      tweens[i].kill();
    }
    root._easeActivityTweens = [];
    clear(root);
  }

  function setupRow(row) {
    var card = row.querySelector('[data-activity-card]');
    var heading = row.querySelector('[data-activity-heading]');
    if (!card) return null;

    var travel = card.offsetHeight * 2.6;
    var state = { t: 0 };

    function paint(t) {
      card.style.transform = 'translateY(' + (-travel * t) + 'px)';
      card.style.opacity = String(1 - t);
      if (heading) heading.style.color = 'rgba(0,0,0,' + (0.12 + 0.88 * t) + ')';
    }

    paint(0);

    return gsap.to(state, {
      t: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: row,
        start: 'top 40%',
        // Give the card more scroll distance and a slightly softer scrub so
        // the upward exit reads as a gradual transition.
        end: '+=130vh',
        scrub: 0.3,
        invalidateOnRefresh: true
      },
      onUpdate: function () {
        paint(state.t);
      }
    });
  }

  function setupDesktop(root) {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);
    kill(root);

    var rows = root.querySelectorAll('[data-activity-row]');
    var tweens = [];
    for (var i = 0; i < rows.length; i++) {
      var tween = setupRow(rows[i]);
      if (tween) tweens.push(tween);
    }
    root._easeActivityTweens = tweens;
  }

  function apply(root, mq) {
    kill(root);
    if (mq.reduce.matches || !mq.desktop.matches) return;
    setupDesktop(root);
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    var mq = media();

    var onChange = function () {
      apply(root, mq);
      if (window.ScrollTrigger) ScrollTrigger.refresh();
    };

    apply(root, mq);
    if (mq.desktop.addEventListener) {
      mq.desktop.addEventListener('change', onChange);
      mq.reduce.addEventListener('change', onChange);
    } else {
      mq.desktop.addListener(onChange);
      mq.reduce.addListener(onChange);
    }

    root._homeEaseActivityCleanup = function () {
      if (mq.desktop.removeEventListener) {
        mq.desktop.removeEventListener('change', onChange);
        mq.reduce.removeEventListener('change', onChange);
      }
      kill(root);
      root.dataset.initialized = 'false';
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-home-ease-activity]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
    if (window.ScrollTrigger) ScrollTrigger.refresh();
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-home-ease-activity]').forEach(function (root) {
      if (root._homeEaseActivityCleanup) root._homeEaseActivityCleanup();
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-ease-status"] && !Shopify.designMode) return;
  try {
    (function () {
  /* 阶段节奏只改这里。时间轴总长为 1。
     liftRatio / liftMaxPx：图片上移比例和上限（1920 设计 px）
     phase1Duration：默认布局淡出结束点，越大消失越晚
     phase2Start：最终态文案开始出现，建议略大于 phase1Duration
     overlayLeft / overlayTop：1920 下阶段 1 图内产品图左上角，按图宽同比
     overlayScale：阶段 1 期间产品图的缩放比例 */
  var TUNE = {
    liftRatio: 0.72,
    liftMaxPx: 240,
    liftFallbackPx: 230,
    phase1Duration: 0.4,
    phase2Start: 0.42,
    phase2Duration: 0.4,
    phase2FadeIn: 0.08,
    overlayLeft: 64,
    overlayTop: 497,
    overlayIntroWidth: 600,
    overlayScale: 1 / 3,
    textFadeStart: 0.6,
    textFadeDuration: 0.28,
    holdStart: 0.88,
    holdDuration: 0.12
  };

  var SELECTORS = {
    stage: '[data-status-stage]',
    intro: '[data-status-intro]',
    introTitle: '[data-status-intro-title]',
    introImage: '[data-status-intro-image]',
    final: '[data-status-final]',
    finalImage: '[data-status-final-image]',
    finalCopy: '[data-status-final-copy]',
    finalText: '[data-status-final-text]'
  };

  function vwPx(designPx) {
    return designPx * Math.min(1, window.innerWidth / 1920);
  }

  function refreshTriggers() {
    if (!window.ScrollTrigger) return;
    if (ScrollTrigger.sort) ScrollTrigger.sort();
    ScrollTrigger.refresh();
  }

  function getParts(root) {
    return {
      stage: root.querySelector(SELECTORS.stage),
      intro: root.querySelector(SELECTORS.intro),
      introTitle: root.querySelector(SELECTORS.introTitle),
      introImage: root.querySelector(SELECTORS.introImage),
      final: root.querySelector(SELECTORS.final),
      finalImage: root.querySelector(SELECTORS.finalImage),
      finalCopy: root.querySelector(SELECTORS.finalCopy),
      finalText: root.querySelector(SELECTORS.finalText)
    };
  }

  function clearStyles(root) {
    var parts = getParts(root);
    Object.keys(parts).forEach(function (key) {
      if (parts[key]) parts[key].style.cssText = '';
    });
    if (parts.introImage) {
      var media = parts.introImage.querySelector('img, svg');
      if (media) media.style.cssText = '';
    }
  }

  function teardown(root) {
    if (root._statusTransitionTimeline) {
      if (root._statusTransitionTimeline.scrollTrigger) {
        root._statusTransitionTimeline.scrollTrigger.kill(true);
      }
      root._statusTransitionTimeline.kill();
      root._statusTransitionTimeline = null;
    }
    clearStyles(root);
  }

  function measureFromCenter(stage, node) {
    var stageBox = stage.getBoundingClientRect();
    var box = node.getBoundingClientRect();
    return (stageBox.left + stageBox.width / 2) - (box.left + box.width / 2);
  }

  function currentY(node) {
    return Number(gsap.getProperty(node, 'y')) || 0;
  }

  function measureIntroLift(stage, intro, introImage) {
    var media = introImage.querySelector('img, svg') || introImage;
    var extra = media.getBoundingClientRect().bottom - currentY(intro) - stage.getBoundingClientRect().bottom;
    var lift = extra > 0 ? extra * TUNE.liftRatio : vwPx(TUNE.liftFallbackPx);
    return -Math.min(lift, vwPx(TUNE.liftMaxPx));
  }

  /* 阶段 1 图片中的产品图初始位置，换算成阶段 2 图片的 transform 位移 */
  function measurePhase2Start(intro, introImage, finalImage) {
    var media = introImage.querySelector('img, svg') || introImage;
    var mediaBox = media.getBoundingClientRect();
    var finalBox = finalImage.getBoundingClientRect();
    var scale = mediaBox.width / TUNE.overlayIntroWidth;
    var overlayX = mediaBox.left + TUNE.overlayLeft * scale;
    var overlayY = mediaBox.top - currentY(intro) + TUNE.overlayTop * scale;
    var imageScale = Number(gsap.getProperty(finalImage, 'scale')) || 1;
    var imageX = Number(gsap.getProperty(finalImage, 'x')) || 0;
    var imageY = Number(gsap.getProperty(finalImage, 'y')) || 0;
    var baseWidth = finalBox.width / imageScale;
    var baseHeight = finalBox.height / imageScale;
    var baseLeft = finalBox.left - imageX - (baseWidth - finalBox.width) / 2;
    var baseTop = finalBox.top - imageY - (baseHeight - finalBox.height) / 2;
    var overlayOffset = (1 - TUNE.overlayScale) / 2;
    return {
      x: overlayX - baseLeft - baseWidth * overlayOffset,
      y: overlayY - baseTop - baseHeight * overlayOffset
    };
  }

  function setupDesktop(root) {
    var parts = getParts(root);
    if (!parts.stage || !parts.introImage || !parts.finalImage || !parts.finalCopy) return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);
    teardown(root);
    parts = getParts(root);

    var imageStart = measurePhase2Start(parts.intro, parts.introImage, parts.finalImage);
    var copyFromCenter = measureFromCenter(parts.stage, parts.finalCopy);

    var timeline = gsap.timeline({
      scrollTrigger: {
        trigger: parts.stage,
        start: 'bottom bottom',
        end: '+=1600',
        pin: true,
        scrub: 0.6,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        onRefresh: function () {
          imageStart = measurePhase2Start(parts.intro, parts.introImage, parts.finalImage);
          copyFromCenter = measureFromCenter(parts.stage, parts.finalCopy);
        }
      }
    });

    timeline.fromTo(
      parts.intro,
      { y: 0 },
      {
        y: function () { return measureIntroLift(parts.stage, parts.intro, parts.introImage); },
        duration: TUNE.phase1Duration,
        ease: 'none'
      },
      0
    );
    if (parts.introTitle) {
      timeline.fromTo(
        parts.introTitle,
        { autoAlpha: 1 },
        { autoAlpha: 0, duration: TUNE.phase1Duration, ease: 'none' },
        0
      );
    }
    timeline.fromTo(
      parts.introImage,
      { autoAlpha: 1 },
      { autoAlpha: 0, duration: TUNE.phase1Duration, ease: 'none' },
      0
    );

    /* 阶段 1 期间，阶段 2 图片作为叠加层从阶段 1 图片内的指定位置开始，
       与阶段 1 图片保持相同的上移距离，并保持 1/3 倍大小。 */
    timeline.fromTo(
      parts.finalImage,
      {
        x: function () { return imageStart.x; },
        y: function () { return imageStart.y; },
        scale: TUNE.overlayScale,
        transformOrigin: '50% 50%'
      },
      {
        x: function () { return imageStart.x; },
        y: function () { return imageStart.y + measureIntroLift(parts.stage, parts.intro, parts.introImage); },
        scale: TUNE.overlayScale,
        duration: TUNE.phase1Duration,
        ease: 'none'
      },
      0
    );

    timeline.fromTo(
      parts.finalImage,
      {
        x: function () { return imageStart.x; },
        y: function () { return imageStart.y + measureIntroLift(parts.stage, parts.intro, parts.introImage); },
        scale: TUNE.overlayScale,
        transformOrigin: '50% 50%'
      },
      {
        x: function () { return -vwPx(16); },
        y: 0,
        scale: 1,
        duration: TUNE.phase2Duration,
        ease: 'none'
      },
      TUNE.phase2Start
    );
    timeline.fromTo(
      parts.finalCopy,
      { x: function () { return copyFromCenter * 0.35; } },
      { x: function () { return vwPx(16); }, duration: TUNE.phase2Duration, ease: 'none' },
      TUNE.phase2Start
    );
    timeline.fromTo(
      parts.finalCopy,
      { autoAlpha: 0 },
      { autoAlpha: 1, duration: TUNE.phase2FadeIn, ease: 'none' },
      TUNE.phase2Start
    );
    if (parts.finalText) {
      timeline.fromTo(
        parts.finalText,
        { autoAlpha: 0 },
        { autoAlpha: 1, duration: TUNE.textFadeDuration, ease: 'none' },
        TUNE.textFadeStart
      );
    }

    timeline.to({}, { duration: TUNE.holdDuration }, TUNE.holdStart);

    root._statusTransitionTimeline = timeline;
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var desktop = window.matchMedia('(min-width: 769px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function apply() {
      if (desktop.matches && !reduce.matches) {
        setupDesktop(root);
      } else {
        teardown(root);
      }
      refreshTriggers();
    }

    apply();
    var onChange = apply;
    if (desktop.addEventListener) {
      desktop.addEventListener('change', onChange);
      reduce.addEventListener('change', onChange);
    } else {
      desktop.addListener(onChange);
      reduce.addListener(onChange);
    }

    root._statusTransitionCleanup = function () {
      if (desktop.removeEventListener) {
        desktop.removeEventListener('change', onChange);
        reduce.removeEventListener('change', onChange);
      } else {
        desktop.removeListener(onChange);
        reduce.removeListener(onChange);
      }
      teardown(root);
      root.dataset.initialized = 'false';
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-home-ease-status-transition]').forEach(init);
    window.setTimeout(refreshTriggers, 0);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-home-ease-status-transition]').forEach(function (root) {
      if (root._statusTransitionCleanup) root._statusTransitionCleanup();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-hero-banner"] && !Shopify.designMode) return;
  try {
    (function () { function init(root) { if (!root || root.dataset.initialized === 'true') return; var swiperEl = root.querySelector('.swiper'); var slideWrappers = swiperEl.querySelectorAll('.swiper-wrapper > .shopify-block'); slideWrappers.forEach(function (slide) { slide.classList.add('swiper-slide'); }); root.querySelectorAll('[data-slide]').forEach(function (slide, index) { slide.setAttribute('aria-hidden', index === 0 ? 'false' : 'true'); }); if (slideWrappers.length < 2 || typeof Swiper === 'undefined') return; root.dataset.initialized = 'true'; var dotsContainer = root.querySelector('[data-dots]'); var dots = Array.from(slideWrappers).map(function (slide, index) { var dot = document.createElement('button'); dot.type = 'button'; dot.className = 'home-hero-banner__dot' + (index === 0 ? ' is-active' : ''); dot.dataset.dot = index; dot.setAttribute('role', 'tab'); dot.setAttribute('aria-label', 'Go to slide ' + (index + 1)); dot.setAttribute('aria-selected', index === 0 ? 'true' : 'false'); dotsContainer.appendChild(dot); return dot; }); dotsContainer.hidden = false; root.querySelector('[data-prev]').hidden = false; root.querySelector('[data-next]').hidden = false; var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; var swiper = new Swiper(swiperEl, { loop: true, autoHeight: true, speed: reduced ? 0 : 650, effect: 'slide', allowTouchMove: true, observer: true, observeParents: true, autoplay: root.dataset.autoplay === 'true' && !reduced ? { delay: Math.max(3000, Math.min(30000, Number(root.dataset.interval) || 5000)), disableOnInteraction: false, pauseOnMouseEnter: true } : false, navigation: { nextEl: root.querySelector('[data-next]'), prevEl: root.querySelector('[data-prev]') }, on: { init: function () { update(this); }, slideChange: function () { update(this); }, resize: function () { this.update(); } } }); function update(instance) { var real = instance.realIndex; dots.forEach(function (dot, index) { var active = index === real; dot.classList.toggle('is-active', active); dot.setAttribute('aria-selected', active ? 'true' : 'false'); }); root.querySelectorAll('[data-slide]').forEach(function (slide, index) { slide.setAttribute('aria-hidden', index === real ? 'false' : 'true'); }); } dots.forEach(function (dot) { dot.addEventListener('click', function () { swiper.slideToLoop(Number(dot.dataset.dot)); }); }); root.addEventListener('shopify:block:select', function (event) { var selected = event.target.closest('.swiper-slide'); var index = Array.prototype.indexOf.call(swiper.slides, selected); if (index >= 0) swiper.slideToLoop(index); }); root._heroSwiper = swiper; if (typeof ResizeObserver === 'function') { var ro = new ResizeObserver(function () { if (root._heroSwiper) root._heroSwiper.update(); }); ro.observe(root); root._heroResizeObserver = ro; } }
  function boot() { if (typeof Swiper === 'undefined') { window.setTimeout(boot, 100); return; } document.querySelectorAll('[data-hero-banner]').forEach(init); } document.addEventListener('DOMContentLoaded', boot); document.addEventListener('shopify:section:load', boot); document.addEventListener('shopify:block:select', boot);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-hero-cleaning-demo"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    var options = Array.from(root.querySelectorAll('[data-option]'));
    var progress = root.querySelector('[data-progress]');
    var scoreValue = root.querySelector('[data-score-value]');
    var form = root.querySelector('.home-hero-cleaning-demo__form');
    var email = root.querySelector('[data-email]');
    var consent = root.querySelector('[data-consent]');
    var submit = root.querySelector('[data-submit]');
    var error = root.querySelector('[data-error]');
    var modal = root.querySelector('[data-modal]');
    var close = root.querySelector('[data-close]');
    if (!progress || !scoreValue || !form || !email || !consent || !submit || !error || !modal || !close) return;
    root.dataset.initialized = 'true';
    var lastFocused = null;
    var previousOverflow = '';
    function renderScore() {
      var score = options.reduce(function (total, option) {
        return option.getAttribute('aria-pressed') === 'true' ? total + (Number(option.dataset.weight) || 0) : total;
      }, 0);
      score = Math.min(100, Math.max(0, Math.round(score)));
      scoreValue.textContent = score + '%';
      progress.setAttribute('aria-valuenow', score);
      progress.firstElementChild.style.width = score + '%';
    }
    function showError(message) {
      error.hidden = !message;
      error.textContent = message || '';
    }
    function syncSubmit() {
      submit.disabled = !consent.checked;
    }
    function parkModal() {
      if (modal.parentElement !== document.body) {
        root._modalHome = modal.parentElement;
        document.body.appendChild(modal);
      }
    }
    function restoreModal() {
      if (root._modalHome && modal.parentElement === document.body) {
        root._modalHome.appendChild(modal);
      }
      root._modalHome = null;
    }
    function cleanPostedUrl() {
      if (!window.history || typeof window.history.replaceState !== 'function') return;
      var url = new URL(window.location.href);
      var dirty = false;
      ['customer_posted', 'contact_posted'].forEach(function (key) {
        if (url.searchParams.has(key)) {
          url.searchParams.delete(key);
          dirty = true;
        }
      });
      var hash = url.hash || '';
      if (hash && (/^#Contact[_-]/i.test(hash) || (form.id && hash.indexOf(form.id) !== -1) || /contact_form/i.test(hash))) {
        url.hash = '';
        dirty = true;
      }
      if (!dirty) return;
      window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    }
    function openModal() {
      lastFocused = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      parkModal();
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      close.focus();
    }
    function closeModal() {
      if (!modal.hidden) {
        modal.hidden = true;
        document.documentElement.style.overflow = previousOverflow;
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      }
      restoreModal();
      cleanPostedUrl();
    }
    function onKeydown(event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
      }
      if (event.key === 'Tab') {
        var focusable = Array.from(modal.querySelectorAll('button,a,[tabindex]:not([tabindex="-1"])'));
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
    options.forEach(function (option) {
      option.addEventListener('click', function () {
        var selected = option.getAttribute('aria-pressed') === 'true';
        option.setAttribute('aria-pressed', String(!selected));
        option.classList.toggle('is-selected', !selected);
        renderScore();
      });
    });
    consent.addEventListener('change', function () {
      syncSubmit();
      showError('');
    });
    email.addEventListener('input', function () {
      email.classList.remove('is-invalid');
      showError('');
    });
    form.addEventListener('submit', function () {
      try {
        sessionStorage.setItem('xlean-cleaning-demo-posted', '1');
      } catch (err) {}
    });
    close.addEventListener('click', closeModal);
    close.addEventListener('keydown', function (event) { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); closeModal(); } });
    document.addEventListener('keydown', onKeydown);
    renderScore();
    syncSubmit();
    var demoPosted = false;
    try {
      demoPosted = sessionStorage.getItem('xlean-cleaning-demo-posted') === '1';
      if (demoPosted) sessionStorage.removeItem('xlean-cleaning-demo-posted');
    } catch (err) {}
    var demoHash = window.location.hash || '';
    if (form.querySelector('[data-posted-success]') && (demoPosted || (form.id && demoHash.indexOf(form.id) !== -1))) {
      openModal();
    }
    root._cleaningDemoDestroy = function () {
      document.removeEventListener('keydown', onKeydown);
      closeModal();
    };
  }
  function boot() {
    document.querySelectorAll('[data-cleaning-demo]').forEach(init);
  }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-cleaning-demo]').forEach(function (root) {
      if (root._cleaningDemoDestroy) root._cleaningDemoDestroy();
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-hero-dual-form"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    var canvas = root.querySelector('[data-canvas]');
    var loader = root.querySelector('[data-loader]');
    if (!canvas || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    var context = canvas.getContext('2d');
    if (!context) return;
    root.dataset.initialized = 'true';
    gsap.registerPlugin(ScrollTrigger);
    var frameCount = Number(root.dataset.frameCount || 66);
    var firstUrl = root.dataset.firstImage;
    var prefix = root.dataset.prefix || 'less_';
    var scrub = root.dataset.scrub || '0.5';
    var images = [];
    var loaded = 0;
    var playhead = { frame: 0 };
    var targetWidth = window.innerWidth * window.devicePixelRatio < 768 ? 450 : window.innerWidth * window.devicePixelRatio < 1700 ? 1440 : 1920;
    canvas.width = targetWidth;
    canvas.height = targetWidth * 9 / 16;
    function frameUrl(index) { var base = firstUrl.split('?')[0].replace(new RegExp(prefix + '\\d+'), prefix + (index + 1)); return base + '?width=' + targetWidth; }
    function updateLoader() { var percent = Math.round(loaded / frameCount * 100); loader.textContent = 'Loading ' + percent + '%'; if (percent >= 100) gsap.to(loader, { opacity: 0, duration: .4, onComplete: function () { loader.remove(); } }); }
    function render() { var image = images[playhead.frame]; if (!image || !image.complete) for (var i = playhead.frame; i >= 0; i -= 1) if (images[i] && images[i].complete) { image = images[i]; break; } if (!image) return; context.clearRect(0, 0, canvas.width, canvas.height); context.drawImage(image, 0, 0, canvas.width, canvas.height); }
    function load(index, priority) { var image = new Image(); if (priority) image.fetchPriority = 'high'; image.onload = function () { images[index] = image; loaded += 1; updateLoader(); if (index === 0) render(); }; image.onerror = function () { loaded += 1; updateLoader(); }; image.src = frameUrl(index); }
    load(0, false);
    var loadTimer = window.setTimeout(function () { for (var i = 1; i < frameCount; i += 1) load(i, true); }, 800);
    var animation = gsap.to(playhead, { frame: frameCount - 1, snap: 'frame', ease: 'none', scrollTrigger: { trigger: root, start: 'top top', end: 'bottom bottom', scrub: Number(scrub), pin: '#' + root.querySelector('.home-hero-dual-form__sticky').id, pinSpacing: false }, onUpdate: render });
    root._dualFormCleanup = function () { window.clearTimeout(loadTimer); if (animation) animation.kill(); if (animation && animation.scrollTrigger) animation.scrollTrigger.kill(); images.forEach(function (image) { image.onload = null; image.onerror = null; }); root.dataset.initialized = 'false'; };
  }
  function boot() { document.querySelectorAll('[data-dual-form]').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot); document.addEventListener('shopify:section:load', boot); document.addEventListener('shopify:block:select', boot); document.addEventListener('shopify:section:unload', function (event) { event.target.querySelectorAll('[data-dual-form]').forEach(function (root) { if (root._dualFormCleanup) root._dualFormCleanup(); }); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-human-intent-adaptive"] && !Shopify.designMode) return;
  try {
    (function () {
  function visibleVideo(root) {
    const videos = root.querySelectorAll('[data-adaptive-hero-video]');
    for (let i = 0; i < videos.length; i++) {
      if (window.getComputedStyle(videos[i]).display !== 'none') return videos[i];
    }
    return videos[0] || null;
  }

  function pauseAll(root) {
    root.querySelectorAll('[data-adaptive-hero-video]').forEach(function (video) {
      video.pause();
    });
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    const videos = root.querySelectorAll('[data-adaptive-hero-video]');
    if (!videos.length) return;
    root.dataset.initialized = 'true';

    const hero = root.querySelector('.home-human-intent-adaptive__hero');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let stopVideo;

    function playCurrent() {
      const video = visibleVideo(root);
      if (!video || reduceMotion) return;
      videos.forEach(function (item) {
        if (item !== video) item.pause();
      });
      video.play().catch(function () {});
    }

    if (window.xleanHomeVideo && hero) {
      stopVideo = window.xleanHomeVideo.bind(hero, videos, playCurrent, function () {
        pauseAll(root);
      });
    }

    root._homeHumanIntentAdaptiveCleanup = function () {
      pauseAll(root);
      if (stopVideo) stopVideo();
      root.dataset.initialized = 'false';
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-home-human-intent-adaptive]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-home-human-intent-adaptive]').forEach(function (root) {
      if (root._homeHumanIntentAdaptiveCleanup) root._homeHumanIntentAdaptiveCleanup();
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-human-intent-transition"] && !Shopify.designMode) return;
  try {
    (function () {
    var SELECTORS = {
      pin: '[data-transition-pin]',
      bg: '[data-transition-bg]',
      waves: '[data-transition-waves]',
      media: '[data-transition-media]',
      copy: '[data-transition-copy]',
      eyebrow: '[data-transition-eyebrow]',
      reveal: '[data-transition-reveal]',
      title: '[data-transition-title]',
      text: '[data-transition-text]',
    };

    var COPY_ELEMENTS = ['eyebrow', 'title', 'text'];
    var COPY_GRADIENT =
      'linear-gradient(90deg, var(--transition-gradient-start) 0%, var(--transition-gradient-end) 100%)';
    var ATMOSPHERE_STAGE_1 = {
      '--atmosphere-c1': '#ffffff',
      '--atmosphere-c2': '#e8f0f8',
      '--atmosphere-c3': '#a8c4e4',
      '--atmosphere-c4': '#7597c7',
      '--atmosphere-glow': 0.8,
      '--transition-atmosphere-opacity': 1,
    };
    var ATMOSPHERE_STAGE_2 = {
      '--atmosphere-c1': '#a8c4e4',
      '--atmosphere-c2': '#6b9ae0',
      '--atmosphere-c3': '#174bcd',
      '--atmosphere-c4': '#00133f',
      '--atmosphere-glow': 0.18,
      '--transition-atmosphere-opacity': 1,
    };
    var ATMOSPHERE_STAGE_3 = {
      '--atmosphere-c1': '#00133f',
      '--atmosphere-c2': '#00133f',
      '--atmosphere-c3': '#00133f',
      '--atmosphere-c4': '#00133f',
      '--atmosphere-glow': 0,
      '--transition-atmosphere-opacity': 1,
    };

    function withTween(stage, tween) {
      var vars = {};
      Object.keys(stage).forEach(function (key) {
        vars[key] = stage[key];
      });
      Object.keys(tween).forEach(function (key) {
        vars[key] = tween[key];
      });
      return vars;
    }

    function applyAtmosphere(el, stage) {
      if (!el) return;
      Object.keys(stage).forEach(function (key) {
        el.style.setProperty(key, String(stage[key]));
      });
    }

    function eachCopy(parts, callback) {
      COPY_ELEMENTS.forEach(function (key) {
        if (parts[key]) callback(parts[key]);
      });
    }

    function getParts(root) {
      return {
        pin: root.querySelector(SELECTORS.pin),
        bg: root.querySelector(SELECTORS.bg),
        waves: root.querySelector(SELECTORS.waves),
        media: root.querySelector(SELECTORS.media),
        copy: root.querySelector(SELECTORS.copy),
        eyebrow: root.querySelector(SELECTORS.eyebrow),
        reveal: root.querySelector(SELECTORS.reveal),
        title: root.querySelector(SELECTORS.title),
        text: root.querySelector(SELECTORS.text),
      };
    }

    function clearStyles(root) {
      var parts = getParts(root);
      Object.keys(parts).forEach(function (key) {
        if (parts[key]) parts[key].style.cssText = '';
      });
      root.style.cssText = '';
    }

    function teardown(root) {
      if (root._intentTriggers) {
        root._intentTriggers.forEach(function (trigger) {
          if (trigger) trigger.kill(true);
        });
        root._intentTriggers = [];
      }
      if (root._intentIntroTimeline) {
        root._intentIntroTimeline.kill();
        root._intentIntroTimeline = null;
      }
      if (root._intentTimeline) {
        root._intentTimeline.kill();
        root._intentTimeline = null;
      }
      if (typeof gsap !== 'undefined') {
        var parts = getParts(root);
        Object.keys(parts).forEach(function (key) {
          if (parts[key]) gsap.set(parts[key], { clearProps: 'all' });
        });
        gsap.set(root, { clearProps: 'all' });
      }
      clearStyles(root);
    }

    function syncMediaImage(root, isDesktop) {
      var picture = root.querySelector('[data-transition-media] picture');
      var img = root.querySelector('[data-transition-media] img');
      var source = picture ? picture.querySelector('source') : null;
      if (!img) return;

      if (source) {
        if (!source.getAttribute('data-media-original')) {
          source.setAttribute('data-media-original', source.getAttribute('media') || '(max-width: 768px)');
        }
        source.media = isDesktop ? 'not all' : source.getAttribute('data-media-original');
      }

      var src = img.getAttribute(isDesktop ? 'data-src-desktop' : 'data-src-mobile');
      var srcset = img.getAttribute(isDesktop ? 'data-srcset-desktop' : 'data-srcset-mobile');
      if (srcset) img.setAttribute('srcset', srcset);
      if (src) img.setAttribute('src', src);
    }

    function showFinal(root) {
      var parts = getParts(root);
      applyAtmosphere(parts.bg, ATMOSPHERE_STAGE_3);
      if (parts.waves) {
        parts.waves.style.transform = 'translateY(0)';
        parts.waves.style.opacity = '1';
      }
      if (parts.media) {
        parts.media.style.opacity = '1';
      }
      if (parts.copy) {
        parts.copy.style.transform = 'translateY(-90px)';
        parts.copy.style.opacity = '0';
      }
    }

    function setupDesktop(root) {
      var parts = getParts(root);
      if (!parts.pin || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        showFinal(root);
        return;
      }

      gsap.registerPlugin(ScrollTrigger);
      teardown(root);
      parts = getParts(root);

      gsap.set(parts.bg, withTween(ATMOSPHERE_STAGE_1, {}));
      gsap.set(parts.waves, { yPercent: 100, opacity: 1 });
      gsap.set(parts.media, { opacity: 0 });
      if (parts.copy) gsap.set(parts.copy, { y: 0, autoAlpha: 1 });
      if (parts.eyebrow) gsap.set(parts.eyebrow, { '--transition-eyebrow-scale': 3, color: '#111111', y: 0 });
      eachCopy(parts, function (element) {
        gsap.set(element, {
          backgroundImage: 'none',
          backgroundClip: 'border-box',
          webkitBackgroundClip: 'border-box',
          '--transition-gradient-start': '#8FE1FF',
          '--transition-gradient-end': '#001EFF',
          color: '#111111',
          webkitTextFillColor: '#111111',
        });
      });

      if (parts.reveal) gsap.set(parts.reveal, { autoAlpha: 0 });
      if (parts.eyebrow && parts.copy) {
        var copyRect = parts.copy.getBoundingClientRect();
        var eyebrowRect = parts.eyebrow.getBoundingClientRect();
        gsap.set(parts.eyebrow, {
          y: copyRect.top + (copyRect.height - eyebrowRect.height) / 2 - eyebrowRect.top,
        });
      }

      // Start when 30% of the section is visible, before the pinned sequence.
      var intro = gsap.timeline({
        scrollTrigger: {
          trigger: parts.pin,
          start: 'top 70%',
          end: 'top top',
          scrub: 0.6,
          invalidateOnRefresh: true,
        },
      });
      intro.to(parts.waves, { yPercent: 62, duration: 1, ease: 'none' }, 0);

      var timeline = gsap.timeline({
        scrollTrigger: {
          trigger: parts.pin,
          start: 'top top',
          end: '+=2200',
          pin: true,
          scrub: 0.6,
          anticipatePin: 1,
          invalidateOnRefresh: true,
        },
      });

      // Stage 1 → 2: the curved blue layers push upward from the bottom.
      timeline.fromTo(parts.waves, { yPercent: 62 }, { yPercent: 0, duration: 0.34, ease: 'none' }, 0);
      timeline.fromTo(
        parts.bg,
        withTween(ATMOSPHERE_STAGE_1, {}),
        withTween(ATMOSPHERE_STAGE_2, { duration: 0.16, ease: 'none' }),
        0
      );
      timeline.to(parts.bg, withTween(ATMOSPHERE_STAGE_3, { duration: 0.18, ease: 'none' }), 0.16);
      if (parts.eyebrow) {
        timeline.to(
          parts.eyebrow,
          { '--transition-eyebrow-scale': 1, y: 0, duration: 0.28, ease: 'none' },
          0.18
        );
      }

      // Stage 3 → 5: fade the banner image in while the eyebrow shrinks.
      // It reaches full opacity at the same point that the copy becomes white,
      // then stays untouched when the copy slides upward.
      timeline.to(parts.media, { opacity: 1, duration: 0.6, ease: 'none' }, 0.18);
      if (parts.reveal) {
        timeline.to(parts.reveal, { autoAlpha: 1, duration: 0.24, ease: 'none' }, 0.34);
      }

      // As the eyebrow shrinks and the lower copy appears, all copy uses one gradient.
      eachCopy(parts, function (element) {
        timeline.set(
          element,
          {
            backgroundImage: COPY_GRADIENT,
            backgroundClip: 'text',
            webkitBackgroundClip: 'text',
            color: 'transparent',
            webkitTextFillColor: 'transparent',
          },
          0.18
        );
      });

      // Hold the gradient, then transition both ends to white uniformly.
      eachCopy(parts, function (element) {
        timeline.set(
          element,
          {
            backgroundImage: COPY_GRADIENT,
            backgroundClip: 'text',
            webkitBackgroundClip: 'text',
          },
          0.46
        );
        timeline.to(
          element,
          {
            '--transition-gradient-start': '#ffffff',
            '--transition-gradient-end': '#ffffff',
            duration: 0.24,
            ease: 'none',
          },
          0.54
        );
        timeline.set(
          element,
          {
            backgroundImage: 'none',
            backgroundClip: 'border-box',
            webkitBackgroundClip: 'border-box',
            color: '#ffffff',
            webkitTextFillColor: '#ffffff',
          },
          0.78
        );
      });

      // Stage 5: hold the complete image and copy briefly.
      timeline.to({}, { duration: 0.16 });

      // Stage 6: move the copy upward while fading it out at the same time.
      if (parts.copy) {
        timeline.to(parts.copy, { yPercent: -100, autoAlpha: 0, duration: 0.82, ease: 'none' }, 0.78);
      }

      root._intentIntroTimeline = intro;
      root._intentTimeline = timeline;
      root._intentTriggers = [intro.scrollTrigger, timeline.scrollTrigger];
    }

    function setupMobile(root) {
      teardown(root);
      root.style.backgroundColor = '#000000';
    }

    function init(root) {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      var desktop = window.matchMedia('(min-width: 769px)');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var applyRaf = 0;

      function run(isDesktop) {
        if (reduce.matches && isDesktop) {
          showFinal(root);
        } else if (isDesktop) {
          setupDesktop(root);
        } else {
          setupMobile(root);
        }
        if (window.ScrollTrigger) ScrollTrigger.refresh();
      }

      function apply(fromChange) {
        var isDesktop = desktop.matches;
        root.setAttribute('data-transition-layout', isDesktop ? 'desktop' : 'mobile');

        if (!fromChange) {
          run(isDesktop);
          return;
        }

        teardown(root);
        syncMediaImage(root, isDesktop);
        if (applyRaf) cancelAnimationFrame(applyRaf);
        applyRaf = requestAnimationFrame(function () {
          applyRaf = 0;
          run(isDesktop);
        });
      }

      apply(false);
      var onChange = function () {
        apply(true);
      };
      if (desktop.addEventListener) {
        desktop.addEventListener('change', onChange);
        reduce.addEventListener('change', onChange);
      } else {
        desktop.addListener(onChange);
        reduce.addListener(onChange);
      }

      root._homeHumanIntentTransitionCleanup = function () {
        if (applyRaf) cancelAnimationFrame(applyRaf);
        if (desktop.removeEventListener) {
          desktop.removeEventListener('change', onChange);
          reduce.removeEventListener('change', onChange);
        } else {
          desktop.removeListener(onChange);
          reduce.removeListener(onChange);
        }
        teardown(root);
        root.removeAttribute('data-transition-layout');
        root.dataset.initialized = 'false';
      };
    }

    function boot(scope) {
      (scope || document).querySelectorAll('[data-home-human-intent-transition]').forEach(init);
    }

    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-home-human-intent-transition]').forEach(function (root) {
        if (root._homeHumanIntentTransitionCleanup) root._homeHumanIntentTransitionCleanup();
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        boot();
      });
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-human-intent-video"] && !Shopify.designMode) return;
  try {
    (function () {
  function visibleVideo(root) {
    const videos = root.querySelectorAll('[data-intent-video]');
    for (let i = 0; i < videos.length; i++) {
      if (window.getComputedStyle(videos[i]).display !== 'none') return videos[i];
    }
    return videos[0] || null;
  }

  function pauseAll(root) {
    root.querySelectorAll('[data-intent-video]').forEach(function (video) {
      video.pause();
    });
  }

  function syncToggle(root, playing) {
    const toggle = root.querySelector('[data-video-toggle]');
    const icon = root.querySelector('[data-video-icon]');
    if (toggle) toggle.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    if (icon) icon.src = playing ? icon.dataset.pauseSrc : icon.dataset.playSrc;
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    const videos = root.querySelectorAll('[data-intent-video]');
    if (!videos.length) return;
    root.dataset.initialized = 'true';

    const frame = root.querySelector('[data-video-frame]');
    const toggle = root.querySelector('[data-video-toggle]');
    let userPaused = false;
    let stopVideo;

    function playCurrent() {
      const video = visibleVideo(root);
      if (!video || userPaused) return;
      video.play().catch(function () {});
      syncToggle(root, true);
    }

    function pauseCurrent() {
      pauseAll(root);
      syncToggle(root, false);
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        const video = visibleVideo(root);
        if (!video) return;
        if (video.paused) {
          userPaused = false;
          playCurrent();
        } else {
          userPaused = true;
          pauseCurrent();
        }
      });
    }

    if (window.xleanHomeVideo && frame) {
      stopVideo = window.xleanHomeVideo.bind(frame, videos, playCurrent, pauseCurrent);
    }

    root._homeHumanIntentVideoCleanup = function () {
      pauseCurrent();
      if (stopVideo) stopVideo();
      root.dataset.initialized = 'false';
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-home-human-intent-video]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-home-human-intent-video]').forEach(function (root) {
      if (root._homeHumanIntentVideoCleanup) root._homeHumanIntentVideoCleanup();
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-product-details"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    var variants = Array.prototype.slice.call(root.querySelectorAll('[data-variant]'));
    var switcher = root.querySelector('[data-switcher]');
    var colors = [];
    variants.forEach(function (variant, i) { if (!switcher) return; var color = document.createElement('button'); color.type = 'button'; color.className = 'home-product-details__color'; color.dataset.colorIndex = i; color.setAttribute('aria-pressed', 'false'); color.innerHTML = '<span class="home-product-details__swatch"></span><span class="home-product-details__color-label"></span>'; color.querySelector('.home-product-details__swatch').style.background = 'linear-gradient(145deg,' + (variant.dataset.swatchStart || '#0c0c0c') + ',' + (variant.dataset.swatchEnd || '#434343') + ')'; color.querySelector('.home-product-details__color-label').textContent = variant.dataset.colorLabel || 'Void Black'; switcher.appendChild(color); });
    colors = Array.prototype.slice.call(root.querySelectorAll('[data-color-index]'));
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    var pageIndex = 0;
    var swipeStartX = 0, swipeStartY = 0, swipeTracking = false;
    var pageTracks = Array.prototype.slice.call(root.querySelectorAll('[data-pages]'));
    function active() { return variants.filter(function (v) { return v.classList.contains('is-active'); })[0]; }
    function pagesOf(variant) { return variant ? Array.prototype.slice.call(variant.querySelectorAll('[data-page]')) : []; }
    function lastPageIndex(variant) { return Math.max(0, pagesOf(variant).length - 1); }
    function renderPages() {
      var variant = active();
      if (!variant) return;
      var last = lastPageIndex(variant);
      if (pageIndex > last) pageIndex = last;
      if (pageIndex < 0) pageIndex = 0;
      pagesOf(variant).forEach(function (p, i) {
        var on = i === pageIndex;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      if (prev) prev.disabled = pageIndex === 0;
      if (next) next.disabled = pageIndex >= last;
    }
    function setPage(index) { pageIndex = index; renderPages(); }
    function chooseColor(index) { variants.forEach(function (v, i) { var on = i === index; v.classList.toggle('is-active', on); v.setAttribute('aria-hidden', on ? 'false' : 'true'); }); colors.forEach(function (c, i) { var on = i === index; c.classList.toggle('is-active', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); }); pageIndex = 0; renderPages(); }
    colors.forEach(function (c, i) { c.dataset.colorIndex = i; c.addEventListener('click', function (event) { event.preventDefault(); event.stopPropagation(); var scrollX = window.scrollX; var scrollY = window.scrollY; chooseColor(Number(c.dataset.colorIndex)); window.scrollTo(scrollX, scrollY); }); });
    if (prev) prev.addEventListener('click', function () { setPage(pageIndex - 1); });
    if (next) next.addEventListener('click', function () { setPage(pageIndex + 1); });
    function onSwipeStart(e) {
      if (!window.matchMedia('(max-width: 768px)').matches) return;
      var t = e.changedTouches ? e.changedTouches[0] : null;
      if (!t) return;
      swipeStartX = t.clientX;
      swipeStartY = t.clientY;
      swipeTracking = true;
    }
    function onSwipeEnd(e) {
      if (!swipeTracking) return;
      swipeTracking = false;
      var t = e.changedTouches ? e.changedTouches[0] : null;
      if (!t) return;
      var dx = t.clientX - swipeStartX;
      var dy = t.clientY - swipeStartY;
      if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
      if (dx < 0) setPage(pageIndex + 1);
      else setPage(pageIndex - 1);
    }
    function onSwipeCancel() { swipeTracking = false; }
    pageTracks.forEach(function (track) {
      track.addEventListener('touchstart', onSwipeStart, { passive: true });
      track.addEventListener('touchend', onSwipeEnd, { passive: true });
      track.addEventListener('touchcancel', onSwipeCancel, { passive: true });
    });
    root.addEventListener('shopify:block:select', function (e) { var selected = e.target.closest('[data-variant]'); if (selected) chooseColor(variants.indexOf(selected)); });
    chooseColor(0);
    root._homeProductDetailsCleanup = function () {
      pageTracks.forEach(function (track) {
        track.removeEventListener('touchstart', onSwipeStart);
        track.removeEventListener('touchend', onSwipeEnd);
        track.removeEventListener('touchcancel', onSwipeCancel);
      });
      root.dataset.initialized = 'false';
    };
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-home-product-details]').forEach(init); }
  document.addEventListener('DOMContentLoaded', function () { boot(); }); document.addEventListener('shopify:section:load', function (e) { boot(e.target); }); document.addEventListener('shopify:section:unload', function (e) { e.target.querySelectorAll('[data-home-product-details]').forEach(function (r) { if (r._homeProductDetailsCleanup) r._homeProductDetailsCleanup(); }); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-product-video"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    var stage = root.querySelector('[data-video-stage]');
    var title = root.querySelector('[data-video-title]');
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-atmosphere-video]'));
    var toggle = root.querySelector('[data-video-toggle]');
    var icon = root.querySelector('[data-video-icon]');
    var watch = root.querySelector('[data-video-watch]');
    var modal = root.querySelector('[data-video-modal]');
    var iframe = root.querySelector('[data-video-iframe]');
    var close = root.querySelector('[data-video-close]');
    var userPaused = false, titleTimer;
    function activeVideo() { return videos.filter(function (v) { return getComputedStyle(v).display !== 'none'; })[0] || videos[0]; }
    function play() { var v = activeVideo(); if (!v || userPaused) return; v.play().catch(function () {}); if (toggle) { toggle.classList.add('is-playing'); toggle.setAttribute('aria-label', 'Pause video'); } if (icon) icon.src = icon.dataset.pauseSrc; }
    function pause() { videos.forEach(function (v) { v.pause(); }); if (toggle) { toggle.classList.remove('is-playing'); toggle.setAttribute('aria-label', 'Play video'); } if (icon) icon.src = icon.dataset.playSrc; }
    if (toggle) toggle.addEventListener('click', function () { var v = activeVideo(); if (!v) return; if (v.paused) { userPaused = false; play(); } else { userPaused = true; pause(); } });
    function onEnter() { play(); if (title && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) { title.classList.remove('is-visible'); void title.offsetWidth; title.classList.add('is-visible'); } }
    function onLeave() { pause(); if (title) { title.classList.remove('is-visible'); clearTimeout(titleTimer); } }
    var stopVideo = window.xleanHomeVideo && stage ? window.xleanHomeVideo.bind(stage, videos, onEnter, onLeave) : null;
    function openModal() { if (!modal || !iframe) return; pause(); iframe.src = 'https://www.youtube.com/embed/' + root.dataset.youtubeId + '?autoplay=1'; modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function closeModal() { if (!modal || !iframe) return; modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); iframe.src = ''; document.body.style.overflow = ''; if (!userPaused && stage && stage.getBoundingClientRect().top < window.innerHeight && stage.getBoundingClientRect().bottom > 0) play(); if (watch) watch.focus(); }
    if (watch) watch.addEventListener('click', openModal); if (close) close.addEventListener('click', closeModal); if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    function onKey(e) { if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal(); }
    document.addEventListener('keydown', onKey);
    root._homeProductVideoCleanup = function () { pause(); if (stopVideo) stopVideo(); document.removeEventListener('keydown', onKey); if (modal && modal.classList.contains('is-open')) closeModal(); root.dataset.initialized = 'false'; };
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-home-product-video]').forEach(init); }
  document.addEventListener('DOMContentLoaded', function () { boot(); }); document.addEventListener('shopify:section:load', function (e) { boot(e.target); }); document.addEventListener('shopify:section:unload', function (e) { e.target.querySelectorAll('[data-home-product-video]').forEach(function (r) { if (r._homeProductVideoCleanup) r._homeProductVideoCleanup(); }); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-ready-video"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-ready-video]'));
    if (!videos.length) return;
    root.dataset.initialized = 'true';

    var frame = root.querySelector('.home-ready-video__frame');
    var toggle = root.querySelector('[data-video-toggle]');
    var icon = root.querySelector('[data-video-icon]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var userPaused = reduceMotion;

    function activeVideo() {
      return videos.filter(function (video) {
        return window.getComputedStyle(video).display !== 'none';
      })[0] || videos[0];
    }

    function setPlaying(playing) {
      if (!toggle) return;
      if (playing) {
        toggle.classList.add('is-playing');
        toggle.setAttribute('aria-label', 'Pause video');
        if (icon) icon.src = icon.dataset.pauseSrc;
      } else {
        toggle.classList.remove('is-playing');
        toggle.setAttribute('aria-label', 'Play video');
        if (icon) icon.src = icon.dataset.playSrc;
      }
    }

    function play() {
      var video = activeVideo();
      if (!video || userPaused) return;
      videos.forEach(function (item) {
        if (item !== video) item.pause();
      });
      video.play().catch(function () {});
      setPlaying(true);
    }

    function pause() {
      videos.forEach(function (video) {
        video.pause();
      });
      setPlaying(false);
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        var video = activeVideo();
        if (!video) return;
        if (video.paused) {
          userPaused = false;
          play();
        } else {
          userPaused = true;
          pause();
        }
      });
    }

    var stopVideo;
    if (window.xleanHomeVideo && frame) {
      stopVideo = window.xleanHomeVideo.bind(frame, videos, play, pause);
    }

    if (reduceMotion) setPlaying(false);

    root._homeReadyVideoCleanup = function () {
      pause();
      if (stopVideo) stopVideo();
      root.dataset.initialized = 'false';
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-home-ready-video]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-home-ready-video]').forEach(function (root) {
      if (root._homeReadyVideoCleanup) root._homeReadyVideoCleanup();
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-station-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
  function playActive(root, swiper) {
    const slides = Array.prototype.slice.call(root.querySelectorAll('.swiper-slide'));
    const activeIndex = swiper ? swiper.activeIndex : 0;
    slides.forEach(function (slide, index) {
      const videos = slide.querySelectorAll('.home-station-slide__media video');
      videos.forEach(function (video) {
        if (index === activeIndex) {
          if (window.xleanHomeVideo) window.xleanHomeVideo.warm(video);
          video.play().catch(function () {});
        } else {
          video.pause();
          video.currentTime = 0;
        }
      });
    });
  }

  function pauseAll(root) {
    root.querySelectorAll('.home-station-slide__media video').forEach(function (video) {
      video.pause();
    });
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    const swiperEl = root.querySelector('[data-carousel-swiper]');
    const prev = root.querySelector('.home-station-carousel__arrow--prev');
    const next = root.querySelector('.home-station-carousel__arrow--next');
    if (!swiperEl) return;
    if (typeof Swiper === 'undefined') {
      setTimeout(function () {
        init(root);
      }, 200);
      return;
    }
    root.dataset.initialized = 'true';

    swiperEl.querySelectorAll('.swiper-wrapper > .shopify-block').forEach(function (slide) {
      slide.classList.add('swiper-slide');
    });

    const swiper = new Swiper(swiperEl, {
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 16,
      speed: 700,
      grabCursor: true,
      watchOverflow: true,
      mousewheel: { forceToAxis: true, sensitivity: 1, releaseOnEdges: true },
      navigation: {
        prevEl: prev,
        nextEl: next
      },
      breakpoints: {
        769: {
          spaceBetween: 23
        }
      }
    });

    function onSlideChange() {
      playActive(root, swiper);
    }

    swiper.on('slideChange', onSlideChange);
    swiper.on('reachEnd', onSlideChange);

    let observer;
    if (window.xleanHomeVideo) {
      observer = {
        disconnect: window.xleanHomeVideo.bind(root, root.querySelectorAll('.home-station-slide__media video'), function () {
          playActive(root, swiper);
        }, function () {
          pauseAll(root);
        })
      };
    } else if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        const entry = entries[0];
        if (entry.isIntersecting) playActive(root, swiper);
        else pauseAll(root);
      }, { threshold: 0.2 });
      observer.observe(root);
    }

    function onBlockSelect(event) {
      const slide = event.target.closest('.swiper-slide');
      if (!slide || !swiperEl.contains(slide)) return;
      const index = Array.prototype.indexOf.call(swiper.slides, slide);
      if (index >= 0) swiper.slideTo(index);
    }

    root.addEventListener('shopify:block:select', onBlockSelect);

    root._homeStationCarouselCleanup = function () {
      pauseAll(root);
      if (observer) observer.disconnect();
      root.removeEventListener('shopify:block:select', onBlockSelect);
      swiper.destroy(true, true);
      root.dataset.initialized = 'false';
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-home-station-carousel]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-home-station-carousel]').forEach(function (root) {
      if (root._homeStationCarouselCleanup) root._homeStationCarouselCleanup();
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
